import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ModalWrapper } from '@microservices/wiskey-react-components'

import {
  CommandPickerController,
  CommandPickerControllerProps,
} from '@components/hookFormControllers/CommandPickerController'
import { ModalFormContainer } from '@components/ModalFormContainer'

import { ActionJSScriptConfig, FormCommand } from '@types'

import { useAddCommandsDialog } from './hooks'

type AddCommandsDialogType = {
  objectCode: string
  onCloseDialog: () => void
  onChangeCommands: (value?: FormCommand[] | null) => void
  commands?: FormCommand[] | null
  commandPickerControllerProps?: Partial<CommandPickerControllerProps>
  jsScriptConfig?: ActionJSScriptConfig
}

export const AddCommandsDialog = (props: AddCommandsDialogType) => {
  const {
    objectCode,
    onCloseDialog,
    onChangeCommands,
    commands,
    commandPickerControllerProps = {},
    jsScriptConfig,
  } = props

  const { t } = useTranslation()

  const {
    state: { methods },
    handlers: { handleSave },
  } = useAddCommandsDialog({
    commands,
    onChangeCommands,
    onCloseDialog,
  })

  const {
    formState: { isDirty },
  } = methods

  return (
    <FormProvider {...methods}>
      <ModalWrapper
        isShow
        disabledSave={!isDirty}
        title={`${t('addDialog.edit')} Commands`}
        width={1000}
        containerStyle={{
          px: 0.5,
          py: 0.5,
        }}
        onClose={onCloseDialog}
        onSave={handleSave}
      >
        <ModalFormContainer maxHeight={600}>
          <CommandPickerController
            {...commandPickerControllerProps}
            isAnotherObjectWithRequestData
            commandName='name'
            containerSx={{ mt: 1 }}
            isSelectedCommandOptionDisabled={false}
            jsScriptConfig={jsScriptConfig}
            name='commands'
            objectCode={objectCode}
          />
        </ModalFormContainer>
      </ModalWrapper>
    </FormProvider>
  )
}
